import { render } from "./ModalContact.vue?vue&type=template&id=627a9cf1"
import script from "./ModalContact.vue?vue&type=script&lang=js"
export * from "./ModalContact.vue?vue&type=script&lang=js"

import "./ModalContact.vue?vue&type=style&index=0&id=627a9cf1&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__